__turbopack_context__.v({
  "navBar": "on_p9q_navBar",
  "navBarLink": "on_p9q_navBarLink",
  "navBarLinkActive": "on_p9q_navBarLinkActive",
});
